export default {
  methods: {
    redirectToFranchisorAccount(franchiseId, versionId) {
      this.$router.push(
        `/account-franchisor?franchise_id=${franchiseId}&version_id=${versionId}`
      )
    },
  },
};
